export class AirOptions {
    timepicker?: boolean;
    format12h?: boolean;
    fullDays?: boolean;
    language?: string;
    hourStep?: number;
    minuteStep?: number;
    enabledDateRanges?: DateRange[];
    EnabledDays?: string;// Only not allow this days enable and clickable; data will be like "sunday,monday..." added on 2024-02-08
    DaysControlEnabled?: boolean=false;// Disable the week ends" added on 2024-02-08
    DateTimePicker_ClickClose_Enabled?: boolean=false;// Control the DateTimePicker OnClick Close Event" added on 2024-02-08
    DateTimePicker_Mode?: DatePickerModes.datepicker;// Control the DateTimePicker swtch between controls 2024-10-09
    showButtons?: boolean;
 
    constructor (options: AirOptions = {} as AirOptions) {
        this.timepicker = !!options.timepicker;
        this.format12h = !!options.format12h;
        this.fullDays = !!options.fullDays;
        this.language = options.language || 'en';
        this.hourStep = options.hourStep || 1;
        this.minuteStep = options.minuteStep || 1;
        this.enabledDateRanges = options.enabledDateRanges || [];
        this.EnabledDays = (options.EnabledDays == undefined || options.EnabledDays == "") ? "" : options.EnabledDays;
        this.DaysControlEnabled = (options.DaysControlEnabled == undefined || options.DaysControlEnabled == false) ? false :true;
        this.DateTimePicker_ClickClose_Enabled = (options.DateTimePicker_ClickClose_Enabled == undefined || options.DateTimePicker_ClickClose_Enabled == false) ? false :true;
        this.DateTimePicker_Mode = (options.DateTimePicker_Mode == undefined || options.DateTimePicker_Mode == null) ? DatePickerModes.datepicker : options.DateTimePicker_Mode;
        this.showButtons = !!options.showButtons;
    }

  isDisabled(date: Date) {
      let WeekEnds:string = 'Sunday,Saturday';
      var options = { weekday: 'long' };
      var dayName = date.toLocaleDateString('en-US', options);
      for (const dateRange of this.enabledDateRanges) {
        //Start - Added on 2024-02-08
        if (this.DaysControlEnabled) {
          if (!(this.EnabledDays.toLowerCase()).includes(dayName.toLowerCase())) {
            return true;
          }
        }
        //End
        if (this.timepicker) {
          let dateRangeStart = new Date(dateRange.start);
          let dateRangeEnd = new Date(dateRange.end);
          if (date.setHours(0, 0, 0, 0) >= dateRangeStart.setHours(0, 0, 0, 0) && date.setHours(0, 0, 0, 0) <= dateRangeEnd.setHours(0,0,0,0)) {
            return false;
          }
        }
        else {
          if (date.setHours(0, 0, 0, 0) >= dateRange.start.setHours(0, 0, 0, 0) && date.setHours(0, 0, 0, 0) <= dateRange.end.setHours(0, 0, 0, 0)) {
            return false;
          }
        }
       
      }

      return !!this.enabledDateRanges.length;
    }
}

export interface DateRange {
  start: Date;
  end: Date;
}


export enum DatePickerModes {
  datepicker = 'datepicker',
  monthpicker = 'monthpicker',
  yearpicker = 'yearpicker'
}
